/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAgeAssuranceState.defs'
export { main as default } from './getAgeAssuranceState.defs'
